import styled from "styled-components";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface StylesheetProps {
  platform: ScreenPlatform;
}

export const Container = styled.div<StylesheetProps>`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  overflow-y: scroll;
  margin-top: ${(props) => (props.platform === "mobile" ? "5rem" : "0")};

  .tabContainer {
    margin-top: -20px;
  }

  /*
   * The tab panel wraps its content in a MUI Box. Only the breathing space below the tab bar is
   * kept: the horizontal padding belongs to each tab, and the blanket rule this replaced also hit
   * every other Box rendered inside the reports.
   */
  > div[role="tabpanel"] > .MuiBox-root {
    padding: 8px 0 0;
  }
`;
